export const API_ERRORS = {
  "points-banks": {
    ACCOUNTS_NOT_FOUND: "Nie znaleziono kont",
    CHARGE_LIMIT_EXHAUSTED:
      "Limit miesięcznych doładowań możliwych do wykonania przez Administratora został wyczerpany. Jeśli chcesz doładować konto pracownika skontaktuj się ze swoim opiekunem klienta",
    CHARGE_NOT_FOUND: "Nie znaleziono doładowania",
    COMPANY_NOT_FOUND: "Nie znaleziono firmy",
    CONSTRAINT_VIOLATION: "Naruszenie ograniczenia",
    DISCHARGE_ALREADY_EXISTS:
      "Rozładowanie o podanym identyfikatorze zewnętrznym już istnieje",
    DISCHARGE_NOT_FOUND: "Nie znaleziono rozładowania",
    EXTERNAL_ID_MUST_BE_UNIQUE:
      "Operacja o podanym identyfikatorze zewnętrznym już istnieje",
    HTTP_MESSAGE_NOT_READABLE: "Nie można odczytać wiadomości HTTP",
    INSUFFICIENT_BALANCE: "Konto nie posiada wystarczającego salda",
    LOCKED_RESOURCE:
      "Zasób jest obecnie używany przez inną osobę lub usługę. Poczekaj chwilę i spróbuj ponownie",
    METHOD_ARGUMENT_TYPE_MISMATCH: "Niezgodność typu argumentu metody",
    MULTIPLE_ACCOUNT_OWNERS:
      "Wszystkie konta muszą należeć do jednego właściciela",
    POINTS_BANK_ALREADY_EXISTS: "Points Bank z podanym id już istnieje",
    POINTS_BANK_BLOCKED: "Bank punktów jest zablokowany",
    POINTS_BANK_NOT_FOUND: "Nie znaleziono banku punktów",
    REQUEST_BODY_VALIDATION_ERROR: "Błąd walidacji danych żądania",
    REQUEST_PART_MISSING: "Brakuje części żądania",
    REQUIRED_QUERY_PARAMETER_MISSING: "Brakuje wymaganego parametru zapytania",
    SENT_BY_RESOLVER_ERROR: "Nieznany typ użytkownika",
    SETTLEMENT_CHANGE_NOT_POSSIBLE:
      "Nie można zmienić sposobu rozliczenia banku",
    UNAUTHORIZED_SENT_BY: "Brak uprawnień do wykonania operacji",
    UNKNOWN_ERROR: "Wystąpił nieznany błąd",
    UNKNOWN_PROPERTY_REFERENCE_ERROR: "Nieznane odwołanie do właściwości",
    UNSUPPORTED_SORT_PROPERTY_ERROR: "Nieobsługiwana właściwość sortowania",
  },
  "recharge-planning-system": {
    NOT_FOUND_ACCOUNT:
      "Nie odnaleziono numeru FK lub użytkownik nie ma konta w banku",
    NOT_POSITIVE_AMOUNT: "Błędna kwota doładowania",
    DUPLICATED_FK_NUMBER: "Zduplikowany numer FK",
    NEGATIVE_AMOUNT: "Błędna kwota doładowania",
    POINTS_BANK_NOT_FOUND: "Nie znaleziono banku punktów",
    CHARGE_DEFINITION_WITHOUT_CHARGE_SOURCE:
      "Definicja opłaty musi zawierać co najmniej jedno źródło opłaty",
    CHARGE_TEMPLATE_WITHOUT_CHARGE_SOURCE:
      "Szablon opłaty musi zawierać co najmniej jedno źródło opłaty",
    CHARGE_TEMPLATE_NOT_FOUND: "Nie znaleziono szablonu opłaty",
    CHARGE_TEMPLATE_VERSION_MISMATCH:
      "Podana wersja szablonu opłaty różni się od zapisanej wersji. Odśwież szablon",
    CHARGE_TEMPLATE_ALREADY_REJECTED: "Szablon opłaty został już odrzucony",
    CHARGE_TEMPLATE_ALREADY_CANCELLED: "Szablon opłaty został już anulowany",
    RESET_DEFINITION_NOT_FOUND: "Nie znaleziono definicji resetu",
    REVIEWER_ACCESS_DENIED: "Recenzent musi być inny niż wnioskodawca",
    CANNOT_APPROVE_CHARGE_TEMPLATE:
      "Nie można zatwierdzić szablonu opłaty. Sprawdź powód",
    CANNOT_REJECT_CHARGE_TEMPLATE: "Nie można odrzucić szablonu opłaty",
    CANNOT_CANCEL_CHARGE_TEMPLATE: "Nie można anulować szablonu opłaty",
    CANNOT_UPDATE_CHARGE_TEMPLATE: "Nie można zaktualizować szablonu opłaty",
    CANNOT_SET_TEMPLATE_STATUS: "Nie można ustawić statusu szablonu opłaty",
    CHARGE_DEFINITION_FOR_TEMPLATE_NOT_FOUND:
      "Nie znaleziono definicji opłaty dla podanego szablonu",
    CANNOT_CREATE_CHARGE_TEMPLATE:
      "Nie można utworzyć szablonu opłaty dla definicji opłaty",
    INVALID_EXECUTION_TIME: "Czas wykonania powinien być w przyszłości",
    CANT_CHANGE_CHARGE_STATUS: "Nie można zmienić statusu opłaty",
    INVALID_CSV_LINE: "Błąd w pliku CSV. Sprawdź linię",
    CSV_FILE_NOT_EXIST: "Plik CSV nie istnieje",
    HTTP_MESSAGE_NOT_READABLE: "Nie można odczytać wiadomości HTTP",
    ILLEGAL_ARGUMENT: "Nieprawidłowy argument",
    CHARGE_DEFINITION_ALREADY_EXISTS: "Definicja opłaty już istnieje",
    CHARGE_DEFINITION_NOT_EXIST: "Definicja opłaty nie istnieje",
    CANNOT_CANCEL_CHARGE_DEFINITION: "Nie można anulować definicji opłaty",
    REQUEST_BODY_VALIDATION_ERROR: "Błąd walidacji danych żądania w polu",
    REQUEST_PART_MISSING: "Brakuje części żądania",
    REQUIRED_QUERY_PARAMETER_MISSING: "Brakuje wymaganego parametru zapytania",
    METHOD_ARGUMENT_TYPE_MISMATCH: "Niezgodność typu argumentu metody",
    CONSTRAINT_VIOLATION: "Naruszenie ograniczenia",
    REQUEST_BODY_FIELD_VALIDATION_ERROR: "Błąd walidacji danych żądania w polu",
    BATCH_UPDATE_ERROR: "Błąd aktualizacji wsadowej",
    CSV_FILE_ALREADY_EXISTS: "Plik CSV już istnieje",
    INVALID_FILE_STRUCTURE: "Nieprawidłowa struktura pliku",
    UNKNOWN_PROPERTY_REFERENCE_ERROR: "Nieznane odwołanie do właściwości",
    FILE_READ_ERROR: "Nie można odczytać pliku. Spróbuj ponownie",
    FILE_UPLOAD_ERROR: "Nie można przesłać pliku. Spróbuj ponownie",
    NOT_EXISTING_GROUPS:
      "Nie można utworzyć definicji opłaty dla nieistniejących grup",
    LOCKED_RESOURCE:
      "Zasób jest obecnie używany przez inną osobę lub usługę. Poczekaj chwilę i spróbuj ponownie",
    EXISTING_ACTIVE_CYCLIC_CHARGE_DEFINITION:
      "Istnieje już aktywna cykliczna definicja opłaty dla banku punktów",
    ACCOUNT_OWNER_NOT_EXIST: "Właściciel konta nie istnieje",
    ACCOUNT_OWNER_WITHOUT_ACCOUNT: "Właściciel konta nie ma przypisanego konta",
    CHARGE_DEFINITION_STATUS_INACTIVE:
      "Status definicji opłaty musi być aktywny",
    CHARGE_DEFINITION_VERSION_MISMATCH:
      "Podana wersja definicji różni się od zapisanej wersji. Odśwież definicję",
    FIRST_CHARGE_ALREADY_PASSED: "Pierwsza opłata została już zrealizowana",
    LAST_CHARGE_ALREADY_PASSED: "Ostatnia opłata została już zrealizowana",
    CANNOT_REPLACE_EXISTING_EXECUTION:
      "Nie udało się anulować zaplanowanego wykonania",
    CANNOT_CANCEL_ONE_TIME_CHARGE: "Nie udało się anulować jednorazowej opłaty",
    CANNOT_CHANGE_CHARGE_TYPE: "Nie można zmienić typu opłaty",
    CANNOT_CANCEL_RESET_DEFINITION: "Nie udało się anulować definicji resetu",
  },
};

export const getErrorMessage = (service, code, details) => {
  if (details && code === "INVALID_CSV_LINE") {
    const baseMessage = API_ERRORS[service]?.[code];
    const causeMessage = API_ERRORS[service]?.[details.cause];
    const detailsError = {
      message: causeMessage,
      line: details.rowNumber,
    };

    return {
      errorMessage: `${baseMessage}. Linia ${details.rowNumber}${
        causeMessage ? `: ${causeMessage}` : ""
      }`,
      details: detailsError,
    };
  }

  const baseMessage = API_ERRORS[service]?.[code];
  if (details?.accountIds?.length) {
    return { errorMessage: `${baseMessage}: ${details.accountIds.join(", ")}` };
  }

  return {
    errorMessage: baseMessage,
  };
};
